import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export class CrudEvent extends EventRow {
    constructor(
        operationName: string,
        resourceName: string,
        resourceType: string,
        concept: string,
        eventName: string = loggerConstants.Event_CRUD,
        status?: string,
        componentName?: string,
        actionType?: string
    ) {
        super(
            eventName, {
                ['operation']: operationName,
                ['component']: componentName ? componentName : '',
                ['resourceName']: resourceName,
                ['resourceType']: resourceType,
                ['concept']: concept
            }
        );
        if (status) {
            this.addToProperties('status', status);
        }
        if (actionType) {
            this.addToProperties('actionType', actionType);
        }
    }
}
